import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {Country} from '../models/country';
import {BaseRestService} from './base-rest.service';
import {AppSettingsService} from './app-settings.service';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {SharedModule} from '../shared.module';

@Injectable({providedIn: SharedModule})
export class CountriesService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'CountriesService'; }

  protected get isAnonymous(): boolean { return true; }

  getList(): Observable<SendBackResult<ArrayResponse<Country>>> { return this.get<ArrayResponse<Country>>('/countries'); }
}
